import { Component, AfterViewInit, Input, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'src/app/shared/interfaces/message';
declare var window:any;

@Component({
    selector: 'app-portal-messages-page',
    templateUrl: './portal-messages-page.component.html'
})
export class PortalMessagesPageComponent implements AfterViewInit {
    pageTitle: string = '';
    allMessagesBlockIcon: string = '';
    allMessagesBlockTitle: string = '';
    allMessagesTablePageSize: number = 0;
    messages: Message[] = [];
    messagesCount: number = 0;
    recentMesagesBlockTitle: string = '';
    recentMessagesBlockIcon: string = '';
    recentMessagesDisplayCount: number = 0;
    pinnedMessagesIds: number[] = [];
    noMessagesText: string = '';

    @Input() set pageData (value:any) {
        const {
            pageTitle,
            allMessagesBlockIcon,
            allMessagesBlockTitle,
            allMessagesTablePageSize,
            messages,
            totalMessagesCount,
            recentMesagesBlockTitle,
            recentMessagesBlockIcon,
            recentMessagesDisplayCount,
            pinnedMessagesIds,
            noMessagesText
          } = value;
        
          this.pageTitle = pageTitle;
          this.allMessagesBlockIcon = allMessagesBlockIcon;
          this.allMessagesBlockTitle = allMessagesBlockTitle;
          this.allMessagesTablePageSize = allMessagesTablePageSize;
          this.messages = messages;
          this.messagesCount = totalMessagesCount;
          this.recentMesagesBlockTitle = recentMesagesBlockTitle;
          this.recentMessagesBlockIcon = recentMessagesBlockIcon;
          this.recentMessagesDisplayCount = recentMessagesDisplayCount;
          this.pinnedMessagesIds = pinnedMessagesIds;
          this.noMessagesText = noMessagesText;
    }

    @ViewChild('eventSender') eventSender!: ElementRef;
    
    constructor(private route: ActivatedRoute) { }

    ngAfterViewInit(): void {
        const id = this.route.snapshot.queryParams['id'];

        if (id) {
          this.openMessagePopup(Number(id));
        }       
    }

    openMessagePopup(id: number) {
        window.MessagePopup.openMessagePopup(id, this.eventSender.nativeElement);
    }
}